import axios from 'axios';
import apiBaseUrl from '@/plugins/api/apiBaseUrl';

export default class Log {
  public static async warn(log: string, data: {}, prefix = 'warn'): Promise<void> {
    try {
      await Log.instance.post('/log.php', { log, data, prefix });
    } catch {
      // logging must never break the caller
    }
  }

  private static instance = axios.create({
    baseURL: apiBaseUrl,
  });
}
